var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 80,
    viewBox: "0 0 60 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.1082 59.1382L46.6258 44.9996H51.4116C52.8194 44.9996 54.0646 44.2184 54.6584 42.9591C55.2521 41.7029 55.0568 40.2623 54.1459 39.2014L41.9385 25.0003H46.4524C47.8742 25.0003 49.1554 24.1644 49.7117 22.8738C50.2616 21.6036 50.0023 20.1255 49.0492 19.1115L31.8201 0.755833C30.8779 -0.251945 29.1202 -0.251945 28.1765 0.755833L10.9458 19.1115C9.99271 20.1255 9.73491 21.6036 10.2833 22.8738C10.8396 24.1644 12.1223 25.0003 13.5442 25.0003H18.0581L5.8491 39.2045C4.94132 40.2639 4.74602 41.7029 5.33818 42.9606C5.93191 44.2184 7.17562 44.9996 8.58495 44.9996H13.3707L0.888336 59.1382C-0.0491314 60.1991 -0.261624 61.6522 0.332106 62.9287C0.918023 64.1865 2.20704 64.9989 3.61481 64.9989H24.9984V68.8191L20.2658 76.3814C19.4346 78.0438 20.6439 80 22.5017 80H37.4949C39.3526 80 40.562 78.0438 39.7308 76.3814L34.9981 68.8191V64.9989H56.3817C57.7895 64.9989 59.0785 64.1865 59.6644 62.9287C60.2582 61.6522 60.0457 60.1991 59.1082 59.1382Z",
    fill: "#F26739"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.2580dc48047c18eccc9c553ce9021959.svg";
export { ForwardRef as ReactComponent };